var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-circular',{staticClass:"pointer",attrs:{"rotate":_vm.rotate,"size":_vm.size,"width":_vm.width,"color":_vm.color,"value":_vm.value}},[_vm._v(" "+_vm._s(_vm.value)+" "+_vm._s(_vm.suffix_symbol)+" ")]),_c('div',[_c('v-chip',{attrs:{"x-small":""}},[_c('strong',[_vm._v(_vm._s(_vm.label))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }